/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface DocumentRequest
 */
export interface DocumentRequest {
  /**
   *
   * @type {string}
   * @memberof DocumentRequest
   */
  name?: string | null
  /**
   *
   * @type {string}
   * @memberof DocumentRequest
   */
  text?: string | null
}

/**
 * Check if a given object implements the DocumentRequest interface.
 */
export function instanceOfDocumentRequest(value: object): boolean {
  let isInstance = true

  return isInstance
}

export function DocumentRequestFromJSON(json: any): DocumentRequest {
  return DocumentRequestFromJSONTyped(json, false)
}

export function DocumentRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): DocumentRequest {
  if (json === undefined || json === null) {
    return json
  }
  return {
    name: !exists(json, 'name') ? undefined : json['name'],
    text: !exists(json, 'text') ? undefined : json['text'],
  }
}

export function DocumentRequestToJSON(value?: DocumentRequest | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    name: value.name,
    text: value.text,
  }
}
